import TopPayingRegions from './TopPayingRegions'
export default TopPayingRegions
